import {
  Modal,
  ContextualMenu,
  mergeStyleSets,
  IconButton,
  TextField,
  Spinner,
  SpinnerSize,
  TooltipHost,
} from "@fluentui/react";
import React, { useEffect, useState, useContext, useRef } from "react";
import {
  getStudyCommunicationData,
  sendMessageService,
} from "../../service/CommunicationService";
import {
  AttachIcon,
  InsertIcon,
  MicrophoneIcon,
  MoreVerticalIcon,
  SearchIcon,
} from "@fluentui/react-icons-mdl2";
import "./Styles/Styles.css";
import SendMessageIcon from "../../components/SVGComponents/SendMessageIcon";
import userContext from "../../context/users/UserContext";
import studyviewerContext from "../../context/studyviewer/StudyviewerContext";
import {
  API_BASE_URL,
  CUSTOM_STYLES,
  TOAST_TYPE,
} from "../../constants/Constants";
import CustomSpinner from "../../components/CustomSpinner";
import Moment from "moment";
import { t } from "i18next";
import studyReportContext from "../../context/studyreport/StudyReportContext";
import themeContext from "../../context/theme/ThemeContext";
import toastContext from "../../context/toast/ToastContext";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
} from "react-device-detect";
import CommunicationBottomSheet from "./CommunicationBottomSheet";
import { normalizeTimeZone } from "../IssuesAndTroubleshooting/helper/helper";
import moment from "moment-timezone";

const CommunicationModal = (props) => {
  const { roles, username, authenticated, loadByUsername, userId, qcReviewer , isActiveData} =
    useContext(userContext);

  const isViewer = false;

  const { getThemeColor, getAlterColor,themeName } = useContext(themeContext);

  const { getConsistentDateFormatFromUTC, alreadyLocked } = useContext(studyReportContext);
  const assignmentData = useContext(studyviewerContext)?.assignmentData;

  const { showToastv2 } = useContext(toastContext);
  const className = `chat__body ${themeName === 'light' ? 'modal-scroll-chat-light' : 'modal-scroll-chat'}`;

  const isChild =
    props.child != undefined && props.child != null ? props.child : false;

  const [seed, setSeed] = useState("");
  const [inputMessage, setInputMessage] = useState("");
  const [roomName, setRoomName] = useState("");
  const [messages, setMessages] = useState([]);
  const bottomRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [isRadiologist, setIsRadiologist] = useState(false);
  const [isAssignedToStudy, setIsAssignedToStudy] = useState(true);
  const [assignmentChecked, setAssignmentChecked] = useState(false);

  const contentStyles = mergeStyleSets({
    root: {
      backgroundColor: "rgba(0, 0, 0, 0.75);",
    },
    container: {
      display: "flex",
      width: "600px",
      overflowY: "hidden",
      overflowX: "hidden",
      borderRadius: "10px",
      boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.90)",
      border: CUSTOM_STYLES.MODAL_BORDER,
    },
    scrollableContent: {
      overflowY: "hidden",
    },
    header: [
      {
        display: "flex",
        alignItems: "center",
        padding: "10px",
        cursor: "pointer",
      },
    ],
    footer: [
      {
        display: "flex",
        justifyContent: "end",
        // background:'#3B3A39',
        padding: "10px",
      },
    ],
    heading: {
      color: "rgb(0 0 0 / 81%)",
      lineHeight: "20px",
      fontSize: "18px",
      fontWeight: "600",
      margin: "0",
    },
    body: {
      height: "60vh",
      // display: 'flex',
      // flexDirection: 'column',
      // overflowY:'auto',
      // padding: '20px 10px 0px 10px',
      // background: '#00000000',
      // color: '#FFFFFF',
      // fontSize:'14px',
      // lineHeight:'20px',
      // fontWeight:'600',
      // fontStyle:'normal',
      // fontFamily:'Open Sans'
    },
  });

  const iconButtonStyles = {
    icon: {
      color: getThemeColor("primary-color"),
      border: "none",
      outline: "none",
    },
    root: {
      marginLeft: "auto",
      marginTop: "4px",
      marginRight: "2px",
      backgroundColor: "transparent",
      selectors: {
        ":hover .ms-Button-icon": {
          color: "white",
        },
      },
    },
    rootHovered: { backgroundColor: "transparent" },
    rootPressed: { backgroundColor: "transparent" },
  };

  const checkForChildStudy = () => {
    if (props.child) {
      return props.child;
    }
    return false;
  };

  const getCommunicationData = async () => {

     if (isRadiologist && !isAssignedToStudy) {
        setMessages([{
            systemMessage: true,
            comment: "Cannot send message - Study not assigned to this radiologist",
            user: { username: "system" }
        }]);
        setLoading(false);
        return;
    }
    setLoading(true);
    const res = await getStudyCommunicationData(
      checkForChildStudy()
        ? window.location.pathname.includes("/studylist")
          ? props.studyParentId
          : props.activeStudyId
        : props.studyParentId
    );
    if (res.status == 200 && res.data.result == "SUCCESS") {
      setMessages(res.data.data);
      if (
        res.data.data.length > 0 &&
        props.setMessageCount != undefined &&
        props.setMessageCount != null &&
        !checkForChildStudy()
      ) {
        props.setMessageCount(res.data.data.length);
      }
      bottomRef.current?.scrollIntoView({ behavior: "smooth" });
      setLoading(false);
    } else {
      setLoading(false);
    }
  };
  const cancelIcon = { iconName: "Cancel" };

 

 useEffect(() => {
    if (roles.length != 0) {
      if (
        props.setDataQueryState != null &&
        props.setDataQueryState != undefined
      ) {
        let newIndex = -1;
        let newData = props.dataQueryState?.data?.rows.filter((row, index) => {
          if (row.id === props.studyParentId) {
            newIndex = index;
            return true;
          }
          return false;
        });
        props.setDataQueryState(() => {
          const newValue = {
            ...props.dataQueryState,
          };
          if (newValue.data.rows[newIndex] != undefined) {
            newValue.data.rows[newIndex].newMessageFlag = false;
          }

          return newValue;
        });
      }
      getCommunicationData();
    }
  }, [roles, username, isAssignedToStudy]);


  useEffect(() => {
    // 👇️ scroll to bottom every time messages change
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

    useEffect(() => {
        if (roles.length > 0 && roles[0] === 'RADIOLOGIST' && props.studyParentId) {
            setIsRadiologist(true);

            const isAssigned = props.studyAssignmentList?.some(
                assignment => assignment.providerId === `R${userId}` || assignment.radiologistId === userId
            );

            if (!isAssigned && props.dataQueryState?.data?.rows) {
                const studyRow = props.dataQueryState.data.rows.find(
                    row => row.id === props.studyParentId
                );
                if (studyRow && studyRow.assignmentList) {
                    const assigned = studyRow.assignmentList.some(
                        assignment => assignment.providerId === `R${userId}` || assignment.radiologistId === userId
                    );
                    setIsAssignedToStudy(assigned);
                }
            } else if (!isAssigned && !props.studylist) {
                setIsAssignedToStudy(
                    assignmentData?.assignedRadiologist === username ||
                    assignmentData?.providerId === `R${userId}` || alreadyLocked
                );
            } else {
                setIsAssignedToStudy(isAssigned || false);
            }
            setAssignmentChecked(true);
        } else {

            setIsAssignedToStudy(true);
            setAssignmentChecked(true);
        }
    }, [roles, userId, props.studyParentId, props.dataQueryState, props.studylist, username, assignmentData, alreadyLocked]);

  function isEmpty(str) {
    return !str.trim().length;
  }

  const sendMessage = async (e) => {
    e.preventDefault();
    let body = {
      feedbackDto: {
        studyId: props.studyParentId,
        comment: inputMessage,
        feedback: null,
        feedbackDate: null,
        user: null,
      },
      baseUrl: API_BASE_URL,
    };
    if (isEmpty(inputMessage)) {
      return;
    }

    try {
      let res = await sendMessageService(body);
      if (res.status == 200 && res.data.result == "SUCCESS") {
        getCommunicationData();
        const element = document.getElementById("main-body-scroll");
        if(element != null){
          element.scrollTop = element.scrollHeight;
        }
        setInputMessage("");
        if (
          props.setDataQueryState != null &&
          props.setDataQueryState != undefined
        ) {
          let newIndex = -1;
          let newData = props.dataQueryState?.data?.rows.filter(
            (row, index) => {
              if (row.id === props.studyParentId) {
                newIndex = index;
                return true;
              }
              return false;
            }
          );
          props.setDataQueryState(() => {
            const newValue = {
              ...props.dataQueryState,
            };
          if (
              newValue.data.rows[newIndex]?.userSpecificMessageCount ==
              undefined
            ) {
              newValue.data.rows[newIndex]["userSpecificMessageCount"] = 1;
            } else {
              newValue.data.rows[newIndex].userSpecificMessageCount =
                newData[0].userSpecificMessageCount + 1;
            }

            newValue.data.rows[newIndex].newMessageFlag = false;
            return newValue;
          });
        }
      } else {
        if (isMobile) {
          props.hideModal();
        }
        showToastv2(TOAST_TYPE.ERROR, t("error.rate-limit-exceeded"));
      }
    } catch (e) {
      if (isMobile) {
        props.hideModal();
      }
      showToastv2(TOAST_TYPE.ERROR, t("string-literals.error-msg"));
    }
  };

  const getFormattedDateTime = (dateFormat) => {
    return (
      dateFormat.getDate() +
      "/" +
      (dateFormat.getMonth() + 1) +
      "/" +
      dateFormat.getFullYear() +
      " " +
      dateFormat.getHours() +
      ":" +
      dateFormat.getMinutes() +
      ":" +
      dateFormat.getSeconds()
    );
  };

  const getFormattedDate = (dateFormat) => {
    return Moment(dateFormat).format("MMM Do YY");
  };

  const getFormatedTime = (dateFormat) => {
    return Moment(dateFormat).format("LT");
  };
  const getFormatedTimeFromUTC = (date) => {
  if (!date) return "No Time";

  // OLD: const rawUserTz = localStorage.getItem("userTimeZone");
  const rawUserTz = sessionStorage.getItem("userTimeZone");
  const userTz = normalizeTimeZone(rawUserTz);
  const systemTz = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // Parse as UTC (IMPORTANT)
  const momentDate = moment.utc(date, "DD-MMM-YY HH:mm", true);

  if (!momentDate.isValid()) return "No Time";

  const displayTz = userTz || systemTz;

  return momentDate
    .tz(displayTz)
    .format("LT");   // shows localized time like 2:45 PM
};


  const customSpinnerStyle = {
    circle: {
      height: "50px",
      width: "50px",
      borderWidth: "5px",
    },
  };

  const getRandomColor = () => {
    let arr = ["#06cf9c", "#a791ff", "#25d366"];
    let randomIndex = Math.floor(Math.random() * arr.length);
    return arr[randomIndex];
  };

  // return isMobile && !props.studylist ? (
  //   <>
  //     <CommunicationBottomSheet
  //       contentStyles={contentStyles}
  //       getThemeColor={getThemeColor}
  //       customSpinnerStyle={customSpinnerStyle}
  //       messages={messages}
  //       username={username}
  //       getFormatedTime={getFormatedTime}
  //       getAlterColor={getAlterColor}
  //       getConsistentDateFormat={getConsistentDateFormat}
  //       bottomRef={bottomRef}
  //       checkForChildStudy={checkForChildStudy}
  //       isViewer={isViewer}
  //       inputMessage={inputMessage}
  //       setInputMessage={setInputMessage}
  //       sendMessage={sendMessage}
  //       loading={loading}
  //     />
  //   </>
  // ) : (
  return (
    <Modal
      isOpen={props.isModalOpen}
      containerClassName={contentStyles.container}
      styles={contentStyles}
      allowTouchBodyScroll={true}
      dragOptions={{
        moveMenuItemText: "Move",
        closeMenuItemText: "Close",
        menu: ContextualMenu,
        dragHandleSelector: "#header-id",
        keepInBounds: true,
      }}
    >
      <>
        <div
          id="header-id"
          style={{
            cursor: "pointer",
            background: !isViewer
              ? getThemeColor("modal-header-footer")
              : "#222",
          }}
          className="modal-header-container-updated"
        >
          <div
            className="modal-header-heading-updated"
            style={{ color: getThemeColor("primary-color") }}
          >
            {t("heading.communication")}
          </div>
          <div className="modal-header-crossicon">
            <IconButton
              styles={iconButtonStyles}
              iconProps={{ iconName: "Cancel" }}
              ariaLabel="Close popup modal"
              onClick={props.hideModal}
              // style={{border:"none",outline:"none",color:"#FFFFFF",border:"1px solid white"}}
              className="modal-header-crossicon-button"
            />
          </div>
        </div>
        <div className={contentStyles.body}>
          <div className="chat">
            <div
              id="main-body-scroll"
              style={{ position: "relative" }}
              className={className}
            >
              <div
                className="whatsapp-image-bg"
                style={{
                  backgroundImage: `url(${window.location.origin}/images/backgroundImageNew.png`,
                  backgroundColor: !isViewer
                    ? getThemeColor("modal-header-footer")
                    : "#222",
                }}
              ></div>

              {loading && (
                <div className="spinner-loading-msg">
                  <Spinner
                    size={SpinnerSize.large}
                    styles={customSpinnerStyle}
                  />
                </div>
              )}

              {!loading && isRadiologist && !isAssignedToStudy && (
                <div className="chat-system-warning">
                    <span>Cannot send message - Study not assigned to this radiologist</span>
                </div>
            )}


              {messages.map((message, index) => (
                <p 
                  style={{background:!(username != message.user.username)?"#005c4b":getAlterColor("#202c33","white")}}
                  key={index}
                  className={`chat__message ${
                    username != message.user.username
                      ? "message-in"
                      : "message-out"
                  } ${username == message.user.username && "chat__receiver"}`}
                >
                  {username == message.user.username && (
                    <span className="tail-container">
                      <TailMessage flag={true} />
                    </span>
                  )}
                  {username != message.user.username && (
                    <span className="tail-container highlight">
                      <TailMessage flag={false} />
                    </span>
                  )}
                  {username != message.user.username && (
                    <span
                      // style={{color: getRandomColor()}}
                      className="chat__name"
                      style={{color:getAlterColor("#a791ff","#7857fc")}}
                    >
                      {message.user.firstName} {message.user.lastName}
                    </span>
                  )}
                  <span
                    className="message-feedback"
                    style={{
                      marginRight: `${
                        message?.feedback?.length > 70 ? "25px" : "68px"
                      }`,
                      color: username == message.user.username?"#e9edef":getAlterColor("#e9edef","#000000")
                    }}
                  >
                    {message.feedback}
                  </span>
                  <span className="chat__timestamp date-time-react-style" style={{color: username == message.user.username?"hsla(0,0%,100%,0.6)":getAlterColor("hsla(0,0%,100%,0.6)","#000000")}}>
                    <span style={{ display: "flex", marginRight: "3px" }}>
                      {getFormatedTimeFromUTC(new Date(message.feedbackDate))}
                    </span>

                    {username == message.user.username && (
                      <span style={{ display: "flex" }}>
                        <DoubleTick />
                      </span>
                    )}
                  </span>
                  <span
                    style={{ color: getAlterColor("hsla(0,0%,100%,0.6)", "") }}
                    className="chat__time"
                  >
                    {getConsistentDateFormatFromUTC(
                      new Date(message.feedbackDate)
                    ).slice(0, 9)}
                    {/* {getFormattedDate())} */}
                  </span>
                </p>
              ))}
              <div ref={bottomRef} />
            </div>
          </div>
        </div>
        <div
          className="chat__footer"
          style={{ display: !checkForChildStudy() ? "flex" : "none" }}
        >
          {/* <InsertIcon /> */}
          <form
            style={{
              background: !isViewer
                ? getThemeColor("modal-header-footer")
                : "#222",
            }}
          >
            <input
              className="chat-input-field"
              value={inputMessage}
              style={{
                color: getThemeColor("primary-color"),
                background: "transparent",
              }}
              onChange={(e) => setInputMessage(e.target.value)}
              placeholder={t("placeholder.type-message")}
              type="text"
              disabled={!isActiveData || (isRadiologist && !isAssignedToStudy)}
            />
            <button onClick={sendMessage} type="submit" disabled={!isActiveData || (isRadiologist && !isAssignedToStudy)}>
              <span style={{ display: "flex", marginLeft: "10px" }}>
                <SendMessageIcon color={getThemeColor("primary-color")} />
              </span>
            </button>
          </form>
        </div>
      </>
    </Modal>
  );
};

export default CommunicationModal;

export const TailMessage = ({ flag }) => {
  const { getAlterColor } = useContext(themeContext);
  return flag ? (
    <svg
      viewBox="0 0 8 13"
      height="13"
      width="8"
      preserveAspectRatio="xMidYMid meet"
      version="1.1"
      x="0px"
      y="0px"
      enableBackground="new 0 0 8 13"
    >
      <title>tail-out</title>
      <path
        opacity="0.13"
        d="M5.188,1H0v11.193l6.467-8.625 C7.526,2.156,6.958,1,5.188,1z"
      ></path>
      <path
        fill="#005c4b"
        d="M5.188,0H0v11.193l6.467-8.625C7.526,1.156,6.958,0,5.188,0z"
      ></path>
    </svg>
  ) : (
    <svg
      viewBox="0 0 8 13"
      height="13"
      width="8"
      preserveAspectRatio="xMidYMid meet"
      version="1.1"
      x="0px"
      y="0px"
      enableBackground="new 0 0 8 13"
    >
      <title>tail-in</title>
      <path
        opacity="0.13"
        fill="#0000000"
        d="M1.533,3.568L8,12.193V1H2.812 C1.042,1,0.474,2.156,1.533,3.568z"
      ></path>
      <path
        fill={getAlterColor("#202c33","#FFF")}
        d="M1.533,2.568L8,11.193V0L2.812,0C1.042,0,0.474,1.156,1.533,2.568z"
      ></path>
    </svg>
  );
};

export const DoubleTick = () => {
  return (
    <>
      <svg
        viewBox="0 0 16 11"
        height="10"
        width="15"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
      >
        <title>msg-dblcheck</title>
        <path
          d="M11.0714 0.652832C10.991 0.585124 10.8894 0.55127 10.7667 0.55127C10.6186 0.55127 10.4916 0.610514 10.3858 0.729004L4.19688 8.36523L1.79112 6.09277C1.7488 6.04622 1.69802 6.01025 1.63877 5.98486C1.57953 5.95947 1.51817 5.94678 1.45469 5.94678C1.32351 5.94678 1.20925 5.99544 1.11192 6.09277L0.800883 6.40381C0.707784 6.49268 0.661235 6.60482 0.661235 6.74023C0.661235 6.87565 0.707784 6.98991 0.800883 7.08301L3.79698 10.0791C3.94509 10.2145 4.11224 10.2822 4.29844 10.2822C4.40424 10.2822 4.5058 10.259 4.60313 10.2124C4.70046 10.1659 4.78086 10.1003 4.84434 10.0156L11.4903 1.59863C11.5623 1.5013 11.5982 1.40186 11.5982 1.30029C11.5982 1.14372 11.5348 1.01888 11.4078 0.925781L11.0714 0.652832ZM8.6212 8.32715C8.43077 8.20866 8.2488 8.09017 8.0753 7.97168C7.99489 7.89128 7.8891 7.85107 7.75791 7.85107C7.6098 7.85107 7.4892 7.90397 7.3961 8.00977L7.10411 8.33984C7.01947 8.43717 6.97715 8.54508 6.97715 8.66357C6.97715 8.79476 7.0237 8.90902 7.1168 9.00635L8.1959 10.0791C8.33132 10.2145 8.49636 10.2822 8.69102 10.2822C8.79681 10.2822 8.89838 10.259 8.99571 10.2124C9.09304 10.1659 9.17556 10.1003 9.24327 10.0156L15.8639 1.62402C15.9358 1.53939 15.9718 1.43994 15.9718 1.32568C15.9718 1.1818 15.9125 1.05697 15.794 0.951172L15.4386 0.678223C15.3582 0.610514 15.2587 0.57666 15.1402 0.57666C14.9964 0.57666 14.8715 0.635905 14.7657 0.754395L8.6212 8.32715Z"
          fill="hsla(0,0%,100%,0.5)"
        ></path>
      </svg>
    </>
  );
};
